import React, { useState } from 'react';

import AppBar from 'components/atoms/AppBar/AppBar';
import IconButton from 'components/molecules/IconButton/IconButton';
import { LogoutIcon } from 'assets/iconsList';
import { MainLogo, MainLogoGray } from 'assets/imageList';
import PropTypes from 'prop-types';
import Box from 'components/atoms/Box/Box';
import { useHeaderStyles } from './headerStyles';
import { useHistory } from 'react-router-dom';
import SvgIcon from 'components/atoms/SvgIcon/SvgIcon';
import SideMenu from './SideMenu';
import MuiMenuIcon from '@material-ui/icons/Menu';
import Typography from 'components/atoms/Typography/Typography';

/**
 * Default AppBar component based on https://material-ui.com/components/app-bar
 * @param {} props All possible props can be found in docs https://material-ui.com/components/app-bar/#api
 */
export default function Header(props) {
  const { children, showLogo, ...rest } = props;
  const classes = useHeaderStyles(props);
  const history = useHistory();

  const [sideMenuOpen, setSideMenuOpen] = useState(false);

  function handleOpened(newValue) {
    setSideMenuOpen(newValue);
  }

  return (
    <Box>
      <AppBar {...rest} className={classes.header}>
        <Box className={classes.headerElements}>
          <Box>
            <IconButton
              onButtonClick={() => {
                window.open('https://www.lifenome.com/', '_blank');
              }}
            >
              <SvgIcon
                width={{ xs: '80px', sm: '100px', md: '138px', lg: '161px' }}
                icon={MainLogoGray}
              />
            </IconButton>
          </Box>

          {showLogo && (
            <Box>
              <IconButton
                onButtonClick={() => {
                  history.push('/');
                }}
              >
                <SvgIcon
                  width={{ xs: '115px', sm: '115px', md: '138px', lg: '161px' }}
                  icon={MainLogo}
                />
              </IconButton>
            </Box>
          )}
          <Box display="flex" flexDirection="row" alignItems="center">
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              style={{ cursor: 'pointer', marginRight: '10px' }}
              onClick={props.onAccountClick}
            >
              <SvgIcon
                width={{ xs: '25px', sm: '30px', md: '35px', lg: '40px' }}
                icon={LogoutIcon}
              />
              <Typography
                style={{ fontWeight: 700, marginLeft: '10px' }}
                variant="body1"
              >
                {props.accountLabel}
              </Typography>
            </Box>
            <MuiMenuIcon
              style={{ color: '#2a343f', fontSize: '50px', cursor: 'pointer' }}
              onClick={() => setSideMenuOpen(!sideMenuOpen)}
            />
          </Box>
        </Box>
      </AppBar>
      <SideMenu
        opened={sideMenuOpen}
        handleOpened={handleOpened}
        onSignOutClick={props.onSignOutClick}
        anchor="right"
      />
    </Box>
  );
}

Header.propTypes = {
  /**
   * The positioning type. The behavior of the different options is described in https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning.
   */
  position: PropTypes.oneOf([
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky',
  ]),
  /**
   * Header background color
   */
  backgroundColor: PropTypes.string,
  /**
   * Hide or show center logo
   */
  showLogo: PropTypes.bool,
};

Header.defaultProps = {
  position: 'relative',
  backgroundColor: '#fff',
  showLogo: false,
};
